<template>
    <div id="cerfaclim">
        <nav class="printableNo">
            <div class="leftNav">
                <div class="innerNav">
                    <img class="navLogout" v-on:click="logout()" src="/assets/logout.png" alt="logout" />
                </div>
            </div>
            <center>
                <img class="main" v-on:click="reload()" src="/assets/logo.png" alt="SO" />
            </center>
            <div class="rightNav">
                <div class="innerNav">
                    <span class="pNav">{{Name}}</span>
                    <img class="logoNav" src="/assets/adpr.png" alt="ADPR" />
                </div>
            </div>
        </nav>
        <div class="outermargin printableNo">
            <button v-on:click="backbtn()" class="btnBack">
                <font-awesome-icon icon="arrow-alt-circle-left" />
            </button>
        </div>
        <div class="pdfcontainer">
            <div v-if="numPages === 1">
                <pdf v-for="i in numPages" :key="i" :src="pdfLink" :page="i" class="pdfViewer"></pdf>
            </div>
            <div v-else>
                <pdf v-for="i in numPages" :key="i" :src="pdfLink" :page="i" class="pdfViewer"></pdf>
            </div>
            <input class="cerfaNum" v-model="cerfa.cerfaNumber" />
            <!-- headerInfo -->
            <textarea class="contractor fix-focus" rows="3" v-model="cerfa.contractor" />
            <textarea class="client1 fix-focus" rows="4" v-model="cerfa.client1" />
            <input class="capacityCerfa fix-focus" v-model="cerfa.capacityCerfa" />
            <!-- device -->
            <input class="deviceId fix-focus" v-model="cerfa.device.id" />
            <input class="deviceFluidType fix-focus" v-model="cerfa.device.fluidType" />
            <input class="deviceTotalCharge fix-focus" v-model="cerfa.device.totalCharge" />
            <input class="deviceTeq fix-focus" v-model="cerfa.device.teq" />
            <!-- intervention type  -->
            <div class="accept interventionType1">
                <input class="fix-focus" type="checkbox" id="interventionType1" v-model="cerfa.interventionType[0]" />
                <label for="interventionType1"></label>
            </div>
            <div class="accept interventionType2">
                <input class="fix-focus" type="checkbox" id="interventionType2" v-model="cerfa.interventionType[1]" />
                <label for="interventionType2"></label>
            </div>
            <div class="accept interventionType3">
                <input class="fix-focus" type="checkbox" id="interventionType3" v-model="cerfa.interventionType[2]" />
                <label for="interventionType3"></label>
            </div>
            <div class="accept interventionType4">
                <input class="fix-focus" type="checkbox" id="interventionType4" v-model="cerfa.interventionType[3]" />
                <label for="interventionType4"></label>
            </div>
            <div class="accept interventionType5">
                <input class="fix-focus" type="checkbox" id="interventionType5" v-model="cerfa.interventionType[4]" />
                <label for="interventionType5"></label>
            </div>
            <div class="accept interventionType6">
                <input class="fix-focus" type="checkbox" id="interventionType6" v-model="cerfa.interventionType[5]" />
                <label for="interventionType6"></label>
            </div>
            <div class="accept interventionType7">
                <input class="fix-focus" type="checkbox" id="interventionType7" v-model="cerfa.interventionType[6]" />
                <label for="interventionType7"></label>
            </div>
            <div class="accept interventionType8">
                <input class="fix-focus" type="checkbox" id="interventionType8" v-model="cerfa.interventionType[7]" />
                <label for="interventionType8"></label>
            </div>
            <textarea class="interventionRemarks fix-focus" rows="4" v-model="cerfa.interventionRemarks" />
            <input class="interventionTypeOther fix-focus" v-model="cerfa.interventionTypeOther" />
            <!-- controle -->
            <input class="isolationControleId fix-focus" v-model="cerfa.isolationControle.id" />
            <input class="isolationControleDate fix-focus date-picker" type="date" v-model="cerfa.isolationControle.controleTimeStamp" />
            <!-- 5 -->
            <div class="accept canDetectLeak1">
                <input class="fix-focus" type="checkbox" id="canDetectLeak1" v-model="cerfa.isolationControle.canDetectLeak[0]" />
                <label for="canDetectLeak1"></label>
            </div>
            <div class="accept canDetectLeak2">
                <input class="fix-focus" type="checkbox" id="canDetectLeak2" v-model="cerfa.isolationControle.canDetectLeak[1]" />
                <label for="canDetectLeak2"></label>
            </div>
            <!-- 7 -->
            <div class="accept hcfc1">
                <input class="fix-focus" type="checkbox" id="hcfc1" v-model="cerfa.isolationControle.hcfc[0]" />
                <label for="hcfc1"></label>
            </div>
            <div class="accept hcfc2">
                <input class="fix-focus" type="checkbox" id="hcfc2" v-model="cerfa.isolationControle.hcfc[1]" />
                <label for="hcfc2"></label>
            </div>
            <div class="accept hcfc3">
                <input class="fix-focus" type="checkbox" id="hcfc3" v-model="cerfa.isolationControle.hcfc[2]" />
                <label for="hcfc3"></label>
            </div>
            <!-- 8 -->
            <div class="accept hfcPfc1">
                <input class="fix-focus" type="checkbox" id="hfcPfc1" v-model="cerfa.isolationControle.hfcPfc[0]" />
                <label for="hfcPfc1"></label>
            </div>
            <div class="accept hfcPfc2">
                <input class="fix-focus" type="checkbox" id="hfcPfc2" v-model="cerfa.isolationControle.hfcPfc[1]" />
                <label for="hfcPfc2"></label>
            </div>
            <div class="accept hfcPfc3">
                <input class="fix-focus" type="checkbox" id="hfcPfc3" v-model="cerfa.isolationControle.hfcPfc[2]" />
                <label for="hfcPfc3"></label>
            </div>
            <!-- 9 -->
            <div class="accept noLeakDetectionSys1">
                <input class="fix-focus" type="checkbox" id="noLeakDetectionSys1" v-model="cerfa.isolationControle.noLeakDetectionSys[0]" />
                <label for="noLeakDetectionSys1"></label>
            </div>
            <div class="accept noLeakDetectionSys2">
                <input class="fix-focus" type="checkbox" id="noLeakDetectionSys2" v-model="cerfa.isolationControle.noLeakDetectionSys[1]" />
                <label for="noLeakDetectionSys2"></label>
            </div>
            <div class="accept noLeakDetectionSys3">
                <input class="fix-focus" type="checkbox" id="noLeakDetectionSys3" v-model="cerfa.isolationControle.noLeakDetectionSys[2]" />
                <label for="noLeakDetectionSys3"></label>
            </div>
            <!-- 10 -->
            <div class="accept leakDetectionSys1">
                <input class="fix-focus" type="checkbox" id="leakDetectionSys1" v-model="cerfa.isolationControle.leakDetectionSys[0]" />
                <label for="leakDetectionSys1"></label>
            </div>
            <div class="accept leakDetectionSys2">
                <input class="fix-focus" type="checkbox" id="leakDetectionSys2" v-model="cerfa.isolationControle.leakDetectionSys[1]" />
                <label for="leakDetectionSys2"></label>
            </div>
            <div class="accept leakDetectionSys3">
                <input class="fix-focus" type="checkbox" id="leakDetectionSys3" v-model="cerfa.isolationControle.leakDetectionSys[2]" />
                <label for="leakDetectionSys3"></label>
            </div>
            <!-- 10 -->
            <div class="accept leakDetected1">
                <input class="fix-focus" type="checkbox" id="leakDetected1" v-model="cerfa.isolationControle.leakDetected[0]" />
                <label for="leakDetected1"></label>
            </div>
            <div class="accept leakDetected2">
                <input class="fix-focus" type="checkbox" id="leakDetected2" v-model="cerfa.isolationControle.leakDetected[1]" />
                <label for="leakDetected2"></label>
            </div>

            <textarea class="firstLeak fix-focus" rows="2" v-model="cerfa.isolationControle.firstLeak" />
            <div class="accept firstLeakHandled1">
                <input class="fix-focus" type="checkbox" id="firstLeakHandled1" v-model="cerfa.isolationControle.firstLeakHandled[0]" />
                <label for="firstLeakHandled1"></label>
            </div>
            <div class="accept firstLeakHandled2">
                <input class="fix-focus" type="checkbox" id="firstLeakHandled2" v-model="cerfa.isolationControle.firstLeakHandled[1]" />
                <label for="firstLeakHandled2"></label>
            </div>
            <!--  -->
            <textarea class="secondLeak fix-focus" rows="2" v-model="cerfa.isolationControle.secondLeak" />
            <div class="accept secondLeakHandled1">
                <input class="fix-focus" type="checkbox" id="secondLeakHandled1" v-model="cerfa.isolationControle.secondLeakHandled[0]" />
                <label for="secondLeakHandled1"></label>
            </div>
            <div class="accept secondLeakHandled2">
                <input class="fix-focus" type="checkbox" id="secondLeakHandled2" v-model="cerfa.isolationControle.secondLeakHandled[1]" />
                <label for="secondLeakHandled2"></label>
            </div>
            <!--  -->
            <textarea class="thirdLeak fix-focus" rows="2" v-model="cerfa.isolationControle.thirdLeak" />
            <div class="accept thirdLeakHandled1">
                <input class="fix-focus" type="checkbox" id="thirdLeakHandled1" v-model="cerfa.isolationControle.thirdLeakHandled[0]" />
                <label for="thirdLeakHandled1"></label>
            </div>
            <div class="accept thirdLeakHandled2">
                <input class="fix-focus" type="checkbox" id="thirdLeakHandled2" v-model="cerfa.isolationControle.thirdLeakHandled[1]" />
                <label for="thirdLeakHandled2"></label>
            </div>
            <!-- 11 -->
            <input class="totalCharge fix-focus" v-model="cerfa.fluidManipulation.totalCharge" />
            <input class="cleanFluid fix-focus" v-model="cerfa.fluidManipulation.cleanFluid" />
            <input class="recycledFluid fix-focus" v-model="cerfa.fluidManipulation.recycledFluid" />
            <input class="regeneredFluid fix-focus" v-model="cerfa.fluidManipulation.regeneredFluid" />
            <input class="totalCollectedFluid fix-focus" v-model="cerfa.fluidManipulation.totalCollectedFluid" />
            <input class="fluidToBeTreated fix-focus" v-model="cerfa.fluidManipulation.fluidToBeTreated" />
            <input class="fluidToBeReUsed fix-focus" v-model="cerfa.fluidManipulation.fluidToBeReUsed" />
            <input class="contentId fix-focus" v-model="cerfa.fluidManipulation.contentId" />
            <!-- 12 -->
            <div class="accept adrRid1">
                <input class="fix-focus" type="checkbox" id="adrRid1" v-model="cerfa.adrRid[0]" />
                <label for="adrRid1"></label>
            </div>
            <div class="accept adrRid2">
                <input class="fix-focus" type="checkbox" id="adrRid2" v-model="cerfa.adrRid[1]" />
                <label for="adrRid2"></label>
            </div>
            <input class="adrRidOtherInput fix-focus" v-model="cerfa.adrRidOtherInput" />
            <!-- 13 -->
            <textarea class="waistShippingInfo fix-focus" rows="3" v-model="cerfa.waistShippingInfo" />
            <!-- 14 -->
            <textarea class="waistTransporter fix-focus" rows="3" v-model="cerfa.waistTransporter" />
            <!-- 15 17 18-->
            <input class="observation fix-focus" v-model="cerfa.observation" />
            <input class="bandCollectionNumber fix-focus" v-model="cerfa.bandCollectionNumber" />
            <input class="bandTraitementNumber fix-focus" v-model="cerfa.bandTraitementNumber" />
            <!-- 16 -->
            <input class="traitementInfo fix-focus" v-model="cerfa.traitementInfo.info" />
            <input class="traitementInfoRdcode fix-focus" v-model="cerfa.traitementInfo.rdCode" />
            <input class="receivedQuantity fix-focus" v-model="cerfa.traitementInfo.receivedQuantity" />
            <!-- operator sig -->
            <input class="operatorName fix-focus" v-model="cerfa.operator.name" />
            <input class="operatorQualityofsigner fix-focus" v-model="cerfa.operator.qualityOfSigner" />
            <input class="operatorSignaturetimestamp date-picker fix-focus" type="date" v-model="cerfa.operator.signatureTimestamp" />
            <input class="operatorVisa fix-focus" v-model="cerfa.operator.visa" />

            <!-- client sig -->
            <input class="clientName fix-focus" v-model="cerfa.client.name" />
            <input class="clientQualityofsigner fix-focus" v-model="cerfa.client.qualityOfSigner" />
            <input class="clientSignaturetimestamp date-picker fix-focus" type="date" v-model="cerfa.client.signatureTimestamp" />
            <input class="clientVisa fix-focus" v-model="cerfa.client.visa" />

            <!-- treatmentSetUp sig -->
            <input class="treatmentSetUpName fix-focus" v-model="cerfa.treatmentSetUp.name" />
            <input class="treatmentSetUpQualityofsigner fix-focus" v-model="cerfa.treatmentSetUp.qualityOfSigner" />
            <input class="treatmentSetUpSignaturetimestamp date-picker fix-focus" type="date" v-model="cerfa.treatmentSetUp.signatureTimestamp" />
            <input class="treatmentVisa fix-focus" v-model="cerfa.treatmentSetUp.visa" />
            <!-- <img :src="sig" class="imgOverPdf" /> -->
        </div>
        <div class="outercircle printableNo">
            <span class="sigBot">Signature :</span>
            <!-- <VueSignaturePad width="400px" height="150px" :class="sigpadclass" ref="signaturePad" /> -->
            <button class="docBtn" :title="title" type="button" :disabled="validated" v-on:click="validatePDF()">Valider et enregistrer le Cerfa</button>
            <button class="docBtn2" :title="title2" type="button" :disabled="!validated" v-on:click="print()">Télécharger le Cerfa en PDF</button>
        </div>
    </div>
</template>

<script>
import pdf from 'vue-pdf';
import axios from 'axios';

export default {
    name: 'Cerfaclim',
    components: {
        pdf
    },
    data() {
        return {
            Name: "client",
            cerfa: {
                cerfaNumber: '',
                contractor: '',
                client1: '',
                capacityCerfa: '',
                device: {
                    id: '',
                    fluidType: '',
                    totalCharge: '',
                    teq: ''
                },
                interventionType: [false, false, false, false, false, false, false, false],
                interventionTypeOther: '',
                interventionRemarks: '',
                isolationControle: {
                    id: '',
                    controleTimeStamp: '',
                    canDetectLeak: [false, false],
                    hcfc: [false, false, false],
                    hfcPfc: [false, false, false],
                    noLeakDetectionSys: [false, false, false],
                    leakDetectionSys: [false, false, false],
                    leakDetected: [false, false],
                    firstLeak: '',
                    firstLeakHandled: [false, false],
                    secondLeak: '',
                    secondLeakHandled: [false, false],
                    thirdLeak: '',
                    thirdLeakHandled: [false, false],
                },
                fluidManipulation: {
                    totalCharge: '',
                    cleanFluid: '',
                    recycledFluid: '',
                    regeneredFluid: '',
                    totalCollectedFluid: '',
                    fluidToBeTreated: '',
                    fluidToBeReUsed: '',
                    contentId: ''
                },
                adrRid: [false, false],
                adrRidOtherInput: '',
                waistShippingInfo: '',
                waistTransporter: '',
                observation: '',
                bandCollectionNumber: '',
                bandTraitementNumber: '',
                traitementInfo: {
                    info: '',
                    rdCode: '',
                    receivedQuantity: ''
                },
                operator: {
                    name: '',
                    qualityOfSigner: '',
                    signatureTimestamp: '',
                    visa: ''
                },
                client: {
                    name: '',
                    qualityOfSigner: '',
                    signatureTimestamp: '',
                    visa: ''
                },
                treatmentSetUp: {
                    name: '',
                    qualityOfSigner: '',
                    signatureTimestamp: '',
                    visa: ''
                },

                status: "signé"
            },
            inquiry: {},
            pdfLink: "/assets/clim.pdf",
            sig: "/assets/nosignature.png",
            numPages: 1,
            validated: false,
            navWidth: 0,
            navMenuVisible: false,
            sigpadclass: "signature",
            files: [],
            title: "Valider le Cerfa",
            title2: "Veuillez valider le Cerfa afin de l'enregistrer"
        };
    },
    methods: {
        reload() {
            this.$cookie.set('currentAriane', "");
            this.$cookie.set('history', "");
            this.$cookie.set('historyQuery', "");
            this.$router.replace({ name: "techhome" });
        },
        validatePDF() {
            //const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
            //if (isEmpty) {
            //    alert("Vous devez signer le document pour le valider");
            //}
            //else {
            //    this.sig = data;
                this.putCLIMsheet();
            //}
        },
        print() {
            window.print();
        },
        logout() {
            this.$cookie.delete('jwt');
            this.$cookie.delete('role');
            this.$cookie.delete('firstName');
            this.$cookie.delete('lastName');
            this.$cookie.delete('currentAriane');
            this.$cookie.delete('history');
            this.$cookie.delete('historyQuery');
            this.$router.replace({ name: "login" });
        },
        backbtn() {

            var strHist = this.$cookie.get('history');
            var arrHist = JSON.parse(strHist);
            var strQuery = this.$cookie.get('historyQuery');
            var arrQuery = JSON.parse(strQuery);

            this.$cookie.set('history', JSON.stringify(arrHist.slice(0, -1)));
            this.$cookie.set('historyQuery', JSON.stringify(arrQuery.slice(0, -1)));

            if (arrHist.length) {
                if (arrQuery[arrQuery.length - 1] !== "" && arrQuery[arrQuery.length - 1] !== "undefined") {
                    this.$router.replace({ name: arrHist[arrHist.length - 1], query: { name: arrQuery[arrQuery.length - 1] } });
                }
                else {
                    this.$router.replace({ name: arrHist[arrHist.length - 1] });
                }
            }
            else {
                this.$cookie.set('currentAriane', "");
                this.$router.replace({ name: "techhome" });
            }
        },
        dataURLtoFile(dataurl, filename) {
            var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
                bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            return new File([u8arr], filename, { type: mime });
        },
        //async putSignature(idCerfa) {
        //    var file = this.dataURLtoFile(this.sig, 'picture.png');
        //    const fd = new FormData();
        //    fd.append('picture', file, "picture.png");
//
        //    var response = await axios.put('https://so.gaviota.fr/api/building/inquiry/clim/tech/' + this.inquiry.name + '/' + idCerfa, fd)
        //    console.log(response);
        //    if (response) {
        //        this.validated = true;
        //        this.title = "Cerfa dejà validé";
        //        this.title2 = "Enregistrer le Cerfa";
        //        this.sigpadclass = "signaturedisable";
        //        this.$refs.signaturePad.lockSignaturePad()
        //        console.log("cerfa validé !");
        //    }
        //},
        async putCLIMsheet() {
            delete this.cerfa._id;
            var response = await axios.put('https://so.gaviota.fr/api/building/inquiry/clim/' + this.inquiry.name, { cerfa: this.cerfa })
            console.log(response);
            if (response) {
                this.validated = true;
                this.title = "Cerfa dejà validé";
                this.title2 = "Enregistrer le Cerfa";
                //this.putSignature(response.data.id);
            }
        },
        async getInquiries(){
            var nameInq = this.$route.query.name.split('/').join('%2F');
            var response = await axios.get('https://so.gaviota.fr/api/building/inquiry/'+nameInq)
            if(response.data.inquiry){
                this.inquiry = response.data.inquiry;
                if (this.inquiry.fioulsheet) {
                    this.getCerfa(this.inquiry.fioulsheet._id);
                }
            }
        },
        async getInquiry(id) {
            axios.defaults.headers.common['Authorization'] = this.$cookie.get('jwt');
            var response = await axios.get('https://so.gaviota.fr/api/building/inquiry/fromintervention/' + id);
            if (response.data.inquiry) {
                this.inquiry = response.data.inquiry;
                if (this.inquiry.climsheet) {
                    this.getCerfa(this.inquiry.climsheet._id);
                }
            }
        },
        async getCerfa(id) {
            var response = await axios.get('https://so.gaviota.fr/api/building/clim/' + id)
            if (response.data.cerfa) {
                this.cerfa = response.data.cerfa;
                if (this.cerfa) {
                    if (this.cerfa.status === "signé") {
                        this.validated = true;
                        this.title = "Cerfa dejà validé";
                        this.title2 = "Enregistrer le cerfa";
                        this.sigpadclass = "signaturedisable";

                        //this.sig = 'data:' + this.cerfa.signatureTech.img.contentType + ';base64,' + btoa(
                        //    new Uint8Array(this.cerfa.signatureTech.img.data.data).reduce((data, byte) => data + String.fromCharCode(byte), '')
                        //);
                        //this.$refs.signaturePad.fromDataURL(this.sig)
                        //this.$refs.signaturePad.lockSignaturePad()
                    }

                    if(this.$cookie.get('role') === "admin" && this.$cookie.get('reloaded') === "false"){
                        this.$cookie.set('reloaded', "true");
                        location.reload();
                    }
                }
            }
        },
        getCookies: function () {
            if (!this.$cookie.get('jwt') || !this.$cookie.get('role') || this.$cookie.get('role') !== "technicien chantier" || !this.$route.query.name) {
                this.logout();
            }
            else {
                this.Name = this.$cookie.get('firstName') + " " + this.$cookie.get('lastName');

                if(this.$cookie.get('role') !== "admin"){
                    this.getInquiry(this.$route.query.name);
                }
                else{
                    this.getInquiries();
                }
            }
        },
    },
    mounted() {
        this.getCookies();
    }
}
</script>

<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css?family=BenchNine");

#cerfaclim {
    font-family: "BenchNine", sans-serif;
    font-stretch: ultra-condensed;
    background-color: #f0f0f0;
    margin: auto;
    border: none;
}
h1 {
    background-color: #1ce83e;
    font-family: "BenchNine", sans-serif;
    font-stretch: ultra-condensed;
    padding-bottom: 15px;
    padding-top: 15px;
    margin: 0;
    font-size: 30px;
    font-weight: 600;
    display: block;
    text-align: center;
    position: relative;
}
h2 {
    border-bottom: 2px solid;
    border-color: #1ce83e;
    color: black;
}
nav {
    top: 0px;
    left: 0px;
    right: 0px;
    margin: 0px;
    position: fixed;
    z-index: 11;
    width: 100%;
    background-color: white;
    border-bottom: 2px solid;
    border-color: #1ce83e;
}
.main {
    display: inline-block;
    cursor: pointer;
    margin: 5px;
}
.rightNav {
    position: absolute;
    top: 0;
    right: 0;
}
.innerNav {
    display: inline-block;
    position: relative;
}
.logoNav {
    vertical-align: middle;
    margin: 5px;
}
.navLogout {
    height: 20px;
    vertical-align: middle;
    cursor: pointer;
    margin: 24px;
}
.leftNav {
    position: absolute;
    top: 0;
    left: 0;
}
.pNav {
    display: inline-block;
    padding-right: 15px;
    font-family: "BenchNine", sans-serif;
    font-size: 20px;
    vertical-align: middle;
}
@media screen and (max-width: 768px) {
    .pNav {
        display: none;
    }
}
.homeName {
    margin: auto;
    font-family: "BenchNine", sans-serif;
    font-size: 20px;
    text-align: center;
    margin: 10px;
}
#circle {
    width: 10px;
    height: 10px;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;
    background: #1ce83e;
    margin: auto;
}
.outermargin {
    background-color: #f0f0f0;
    padding: 15px;
}
.btnBack {
    border: none;
    cursor: pointer;
    display: inline-block;
    font-size: 30px;
    margin-top: 80px;
    margin-left: 50px;
    background-color: #f0f0f0;
}
.pdfcontainer {
    width: 800px;
    margin: auto;
    position: relative;
    .fix-focus:focus {
        outline: none;
    }
    .date-picker::-webkit-calendar-picker-indicator {
        opacity: 1;
    }
    .date-picker::-webkit-clear-button,
    .date-picker::-webkit-inner-spin-button {
        display: none;
        -webkit-appearance: none;
    }
    .cerfaNum {
        position: absolute;
        bottom: 1068px;
        right: 47px;
        width: 69px;
        font-size: 14px;
        background-color: transparent;
        border: 0px solid;
    }
    .contractor {
        position: absolute;
        bottom: 994px;
        left: 27px;
        width: 352px;
        font-size: 14px;
        background-color: transparent;
        border: 0px solid;
        resize: none;
        overflow: hidden;
    }
    .client {
        position: absolute;
        bottom: 980px;
        right: 55px;
        width: 352px;
        font-size: 14px;
        background-color: transparent;
        border: 0px solid;
        resize: none;
        overflow: hidden;
    }
    .capacityCerfa {
        position: absolute;
        bottom: 972px;
        left: 185px;
        width: 190px;
        font-size: 14px;
        background-color: transparent;
        border: 0px solid;
    }
    .deviceId {
        position: absolute;
        bottom: 952px;
        left: 330px;
        width: 390px;
        font-size: 14px;
        background-color: transparent;
        border: 0px solid;
    }
    .deviceFluidType {
        position: absolute;
        bottom: 931px;
        left: 350px;
        width: 125px;
        font-size: 14px;
        background-color: transparent;
        border: 0px solid;
    }
    .deviceTotalCharge {
        position: absolute;
        bottom: 931px;
        left: 551px;
        width: 180px;
        font-size: 14px;
        background-color: transparent;
        border: 0px solid;
    }
    .deviceTeq {
        position: absolute;
        bottom: 910px;
        left: 330px;
        width: 365px;
        font-size: 14px;
        background-color: transparent;
        border: 0px solid;
    }
    .interventionType1 {
        position: absolute;
        bottom: 886px;
        left: 137px;
        font-size: 14px;
        background-color: transparent;
    }
    .interventionType2 {
        position: absolute;
        bottom: 882px;
        left: 322px;
        font-size: 14px;
        background-color: transparent;
    }
    .interventionType3 {
        position: absolute;
        bottom: 863px;
        left: 137px;
        font-size: 14px;
        background-color: transparent;
    }
    .interventionType4 {
        position: absolute;
        bottom: 863px;
        left: 322px;
        font-size: 14px;
        background-color: transparent;
    }
    .interventionType5 {
        position: absolute;
        bottom: 839px;
        left: 137px;
        font-size: 14px;
        background-color: transparent;
    }
    .interventionType6 {
        position: absolute;
        bottom: 839px;
        left: 322px;
        font-size: 14px;
        background-color: transparent;
    }
    .interventionType7 {
        position: absolute;
        bottom: 815px;
        left: 137px;
        font-size: 14px;
        background-color: transparent;
    }
    .interventionType8 {
        position: absolute;
        bottom: 815px;
        left: 322px;
        font-size: 14px;
        background-color: transparent;
    }
    .interventionRemarks {
        position: absolute;
        bottom: 837px;
        right: 45px;
        width: 143px;
        font-size: 14px;
        background-color: transparent;
        border: 0px solid;
        resize: none;
        overflow: hidden;
    }
    .interventionTypeOther {
        position: absolute;
        bottom: 815px;
        left: 442px;
        width: 310px;
        font-size: 14px;
        background-color: transparent;
        border: 0px solid;
    }
    .isolationControleId {
        position: absolute;
        bottom: 771px;
        left: 220px;
        width: 255px;
        font-size: 14px;
        background-color: transparent;
        border: 0px solid;
    }

    .isolationControleDate {
        position: absolute;
        bottom: 771px;
        left: 479px;
        width: 275px;
        height: 23px;
        font-size: 14px;
        background-color: #e2ebcd;
        border: 0px solid;
    }
    .canDetectLeak1 {
        position: absolute;
        bottom: 751px;
        left: 368px;

        font-size: 14px;
        background-color: transparent;
    }
    .canDetectLeak2 {
        position: absolute;
        bottom: 752px;
        left: 517px;
        font-size: 14px;
        background-color: transparent;
    }
    .hcfc1 {
        position: absolute;
        bottom: 710px;
        left: 327px;
        font-size: 14px;
        background-color: transparent;
    }
    .hcfc2 {
        position: absolute;
        bottom: 710px;
        left: 474px;
        font-size: 14px;
        background-color: transparent;
    }
    .hcfc3 {
        position: absolute;
        bottom: 710px;
        left: 628px;

        font-size: 14px;
        background-color: transparent;
    }
    .hfcPfc1 {
        position: absolute;
        bottom: 686px;
        left: 327px;
        font-size: 14px;
        background-color: transparent;
    }
    .hfcPfc2 {
        position: absolute;
        bottom: 686px;
        left: 474px;
        font-size: 14px;
        background-color: transparent;
    }
    .hfcPfc3 {
        position: absolute;
        bottom: 686px;
        left: 628px;
        font-size: 14px;
        background-color: transparent;
    }
    .noLeakDetectionSys1 {
        position: absolute;
        bottom: 665px;
        left: 327px;
        font-size: 14px;
        background-color: transparent;
    }
    .noLeakDetectionSys2 {
        position: absolute;
        bottom: 665px;
        left: 474px;
        font-size: 14px;
        background-color: transparent;
    }
    .noLeakDetectionSys3 {
        position: absolute;
        bottom: 665px;
        left: 628px;
        font-size: 14px;
        background-color: transparent;
    }
    .leakDetectionSys1 {
        position: absolute;
        bottom: 642px;
        left: 327px;
        font-size: 14px;
        background-color: transparent;
    }
    .leakDetectionSys2 {
        position: absolute;
        bottom: 642px;
        left: 474px;
        font-size: 14px;
        background-color: transparent;
    }
    .leakDetectionSys3 {
        position: absolute;
        bottom: 642px;
        left: 628px;
        font-size: 14px;
        background-color: transparent;
    }
    .leakDetected1 {
        position: absolute;
        bottom: 619px;
        left: 350px;
        font-size: 14px;
        background-color: transparent;
    }
    .leakDetected2 {
        position: absolute;
        bottom: 619px;
        left: 470px;
        font-size: 14px;
        background-color: transparent;
    }
    .firstLeak {
        position: absolute;
        bottom: 558px;
        left: 164px;
        width: 450px;
        font-size: 14px;
        background-color: transparent;
        border: 0px solid;
        resize: none;
        overflow: hidden;
    }
    .firstLeak {
        position: absolute;
        bottom: 558px;
        left: 164px;
        width: 450px;
        font-size: 14px;
        background-color: transparent;
        border: 0px solid;
        resize: none;
        overflow: hidden;
    }
    .firstLeakHandled1 {
        position: absolute;
        bottom: 576px;
        right: 127px;
        font-size: 14px;
        background-color: transparent;
    }
    .firstLeakHandled2 {
        position: absolute;
        bottom: 556px;
        right: 127px;
        font-size: 14px;
        background-color: transparent;
    }
    .secondLeak {
        position: absolute;
        bottom: 518px;
        left: 164px;
        width: 450px;
        font-size: 14px;
        background-color: transparent;
        border: 0px solid;
        resize: none;
        overflow: hidden;
    }
    .secondLeakHandled1 {
        position: absolute;
        bottom: 536px;
        right: 127px;
        font-size: 14px;
        background-color: transparent;
    }
    .secondLeakHandled2 {
        position: absolute;
        bottom: 516px;
        right: 127px;
        font-size: 14px;
        background-color: transparent;
    }

    .thirdLeak {
        position: absolute;
        bottom: 477px;
        left: 164px;
        width: 450px;
        font-size: 14px;
        background-color: transparent;
        border: 0px solid;
        resize: none;
        overflow: hidden;
    }
    .thirdLeakHandled1 {
        position: absolute;
        bottom: 496px;
        right: 128px;
        font-size: 14px;
        background-color: transparent;
    }
    .thirdLeakHandled2 {
        position: absolute;
        bottom: 476px;
        right: 128px;
        font-size: 14px;
        background-color: transparent;
    }

    .totalCharge {
        position: absolute;
        bottom: 429px;
        right: 433px;
        width: 140px;
        font-size: 14px;
        background-color: transparent;
        border: 0px solid;
    }
    .cleanFluid {
        position: absolute;
        bottom: 405px;
        right: 433px;
        width: 88px;
        font-size: 14px;
        background-color: transparent;
        border: 0px solid;
    }
    .recycledFluid {
        position: absolute;
        bottom: 386px;
        right: 433px;
        width: 88px;
        font-size: 14px;
        background-color: transparent;
        border: 0px solid;
    }
    .regeneredFluid {
        position: absolute;
        bottom: 369px;
        right: 433px;
        width: 88px;
        font-size: 14px;
        background-color: transparent;
        border: 0px solid;
    }
    .totalCollectedFluid {
        position: absolute;
        bottom: 429px;
        right: 64px;
        width: 105px;
        font-size: 14px;
        background-color: transparent;
        border: 0px solid;
    }
    .fluidToBeTreated {
        position: absolute;
        bottom: 408px;
        right: 64px;
        width: 71px;
        font-size: 14px;
        background-color: transparent;
        border: 0px solid;
    }
    .fluidToBeReUsed {
        position: absolute;
        bottom: 388px;
        right: 64px;
        width: 71px;
        font-size: 14px;
        background-color: transparent;
        border: 0px solid;
    }
    .contentId {
        position: absolute;
        bottom: 368px;
        right: 47px;
        width: 216px;
        font-size: 14px;
        background-color: transparent;
        border: 0px solid;
    }
    .adrRid1 {
        position: absolute;
        bottom: 331px;
        left: 193px;
        font-size: 14px;
        background-color: transparent;
    }
    .adrRid2 {
        position: absolute;
        bottom: 311px;
        left: 193px;
        font-size: 14px;
        background-color: transparent;
    }

    .adrRidOtherInput {
        position: absolute;
        bottom: 311px;
        right: 47px;
        width: 472px;
        font-size: 14px;
        background-color: transparent;
        border: 0px solid;
    }
    .waistShippingInfo {
        position: absolute;
        bottom: 239px;
        left: 28px;
        width: 351px;
        font-size: 14px;
        background-color: transparent;
        border: 0px solid;
        resize: none;
        overflow: hidden;
    }
    .waistTransporter {
        position: absolute;
        bottom: 239px;
        left: 387px;
        width: 359px;
        font-size: 14px;
        background-color: transparent;
        border: 0px solid;
        resize: none;
        overflow: hidden;
    }
    .observation {
        position: absolute;
        bottom: 222px;
        left: 117px;
        width: 263px;
        font-size: 14px;
        background-color: transparent;
        border: 0px solid;
    }
    .bandCollectionNumber {
        position: absolute;
        bottom: 186px;
        left: 240px;
        width: 140px;
        font-size: 14px;
        background-color: transparent;
        border: 0px solid;
    }
    .bandTraitementNumber {
        position: absolute;
        bottom: 165px;
        left: 228px;
        width: 152px;
        font-size: 14px;
        background-color: transparent;
        border: 0px solid;
    }
    .traitementInfo {
        position: absolute;
        bottom: 203px;
        left: 386px;
        width: 363px;
        font-size: 14px;
        background-color: transparent;
        border: 0px solid;
    }
    .traitementInfoRdcode {
        position: absolute;
        bottom: 185px;
        left: 460px;
        width: 290px;
        font-size: 14px;
        background-color: transparent;
        border: 0px solid;
    }
    .receivedQuantity {
        position: absolute;
        bottom: 165px;
        left: 535px;
        width: 217px;
        font-size: 14px;
        background-color: transparent;
        border: 0px solid;
    }

    .operatorName {
        position: absolute;
        bottom: 104px;
        left: 147px;
        width: 179px;
        font-size: 14px;
        background-color: transparent;
        border: 0px solid;
    }
    .operatorQualityofsigner {
        position: absolute;
        bottom: 83px;
        left: 147px;
        width: 180px;
        font-size: 14px;
        background-color: transparent;
        border: 0px solid;
    }
    .operatorSignaturetimestamp {
        position: absolute;
        bottom: 62px;
        left: 147px;
        width: 118px;
        font-size: 14px;
        background-color: transparent;
        border: 0px solid;
    }
    .operatorVisa {
        position: absolute;
        bottom: 42px;
        left: 147px;
        width: 178px;
        font-size: 14px;
        background-color: transparent;
        border: 0px solid;
    }
    .clientName {
        position: absolute;
        bottom: 104px;
        left: 330px;
        width: 200px;
        font-size: 14px;
        background-color: transparent;
        border: 0px solid;
    }
    .clientQualityofsigner {
        position: absolute;
        bottom: 83px;
        left: 332px;
        width: 195px;
        font-size: 14px;
        background-color: transparent;
        border: 0px solid;
    }
    .clientSignaturetimestamp {
        position: absolute;
        bottom: 62px;
        left: 332px;
        width: 118px;
        font-size: 14px;
        background-color: transparent;
        border: 0px solid;
    }
    .clientVisa {
        position: absolute;
        bottom: 42px;
        left: 332px;
        width: 195px;
        font-size: 14px;
        background-color: transparent;
        border: 0px solid;
    }
    .treatmentSetUpName {
        position: absolute;
        bottom: 104px;
        left: 534px;
        width: 217px;
        font-size: 14px;
        background-color: transparent;
        border: 0px solid;
    }
    .treatmentSetUpQualityofsigner {
        position: absolute;
        bottom: 83px;
        left: 534px;
        width: 217px;
        font-size: 14px;
        background-color: transparent;
        border: 0px solid;
    }
    .treatmentSetUpSignaturetimestamp {
        position: absolute;
        bottom: 62px;
        left: 534px;
        width: 118px;
        font-size: 14px;
        background-color: transparent;
        border: 0px solid;
    }
    .treatmentVisa {
        position: absolute;
        bottom: 42px;
        left: 534px;
        width: 215px;
        font-size: 14px;
        background-color: transparent;
        border: 0px solid;
    }

    .accept {
        margin-bottom: 20px;
        input[type="checkbox"] {
            display: none;
        }
        input[type="checkbox"] + label {
            display: block;
            position: relative;
            padding-left: 35px;
            margin-bottom: 20px;
            font-size: 0.9rem;
            cursor: pointer;
            -webkit-user-select: none;
            -moz-user-select: none;
            -ms-user-select: none;
        }
        input[type="checkbox"] + label:last-child {
            margin-bottom: 0;
        }
        input[type="checkbox"] + label:before {
            content: "";
            display: block;
            width: 8px;
            height: 8px;
            // border: 2px solid black;
            position: absolute;
            left: 6px;
            top: 6px;
            -webkit-transition: all 0.12s, border-color 0.08s;
            transition: all 0.12s, border-color 0.08s;
        }
        input[type="checkbox"]:checked + label:before {
            width: 10px;
            top: 0px;
            left: 5px;
            border-radius: 0;
            border: 2px solid black;
            opacity: 1;
            border-top-color: transparent;
            border-left-color: transparent;
            -webkit-transform: rotate(45deg);
            transform: rotate(45deg);
        }
    }
}
.pdfViewer {
    width: 100%;
}
.imgOverPdf {
    position: absolute;
    bottom: 35px;
    left: 230px;
    width: 100px;
    height: 48px;
}

.outercircle {
    background-color: #f0f0f0;
    padding: 50px;
    width: 800px;
    margin: auto;
    position: relative;
}
.docBtn {
    font-family: "BenchNine", sans-serif;
    font-stretch: ultra-condensed;
    display: inline-block;
    border: none;
    color: #1ce83e;
    font-size: 18px;
    cursor: pointer;
    background-color: black;
    border-radius: 10px;
    margin: 0px;
    margin-bottom: 50px;
    margin-right: 100px;
    width: 200px;
    position: absolute;
    top: 107px;
    right: 0px;
}
.docBtn2 {
    font-family: "BenchNine", sans-serif;
    font-stretch: ultra-condensed;
    display: inline-block;
    border: none;
    color: #1ce83e;
    font-size: 18px;
    cursor: pointer;
    background-color: black;
    border-radius: 10px;
    margin: 0px;
    margin-bottom: 50px;
    margin-right: 100px;
    width: 200px;
    position: absolute;
    top: 166px;
    right: 0px;
}
.docBtn3 {
    font-family: "BenchNine", sans-serif;
    font-stretch: ultra-condensed;
    display: inline-block;
    border: none;
    color: #1ce83e;
    font-size: 18px;
    cursor: pointer;
    background-color: black;
    border-radius: 10px;
    margin: 0px;
    margin-bottom: 50px;
    margin-left: 100px;
    width: 200px;
    position: absolute;
    top: 30px;
    left: 250px;
}
button:disabled,
button[disabled] {
    border: 1px solid #999999;
    background-color: #cccccc;
    color: #666666;
    cursor: no-drop;
}
@media print {
    .printableNo {
        display: none;
    }
}
@page {
    size: auto;
    margin: 0mm;
}
.sideNav {
    background-clip: border-box;
    background-color: #fff;
    background-origin: padding-box;
    box-sizing: border-box;
    background-color: #333;
    display: block;
    height: 100%;
    overflow: auto;
    box-shadow: 8px 0px 6px -6px #999;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10;
    -webkit-transition: width 0.5s;
    transition: width 0.5s;
}
.navsidecontent {
    color: white;
    font-family: "BenchNine", sans-serif;
    margin-top: 65px;
    margin-left: 30px;
    margin-right: 30px;
    -webkit-transition: width 0.5s;
    transition: width 0.5s;
}
.navtitle {
    margin: 10px;
    margin-top: 15px;
    padding-top: 5px;
    font-size: 24px;
    font-weight: 700;
    text-align: center;
    border-top: 1px solid;
    border-color: #eee;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    cursor: default;
}
.navsubtitle {
    margin: 7px;
    font-size: 18px;
    font-weight: 400;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    cursor: pointer;
}
.navsubtitle:hover {
    color: #999;
}
.noborder {
    border: none;
    margin-top: 5px;
    padding-top: 0px;
}
.logout {
    padding-top: 50px;
    cursor: pointer;
}

/* width */
::-webkit-scrollbar {
    width: 6px;
}

/* Track */
::-webkit-scrollbar-track {
    background: #ddd;
}

/* Handle */
::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 3px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
    background: #555;
}
.signature {
    display: inline-block;
    border: 2px solid;
    border-color: #888;
    background-color: white;
}
.signaturedisable {
    display: inline-block;
    border: 2px solid;
    border-color: #888;
    background-color: #cccccc;
    cursor: no-drop;
}
.sigBot {
    font-family: "BenchNine", sans-serif;
    display: block;
    font-size: 18px;
}
</style>